import { Alert, Box, Snackbar } from "@mui/material";
import cuid from "cuid";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { PTTranslate } from "../components/ui";

const AlertContext = createContext();

const AlertProvider = ({ children }) => {
  const [alertMessages, setAlertMessages] = useState([]);

  // useCallback ensures hideAlert function identity is stable
  const hideAlert = useCallback((id) => {
    setAlertMessages((prev) => prev.filter((alert) => alert.id !== id));
  }, []); // Empty dependency array is safe as setAlertMessages is stable

  // useCallback ensures showAlert function identity is stable
  const showAlert = useCallback(
    (type, message, duration = 5000) => { // Default duration 5 seconds
      const newAlert = {
        id: cuid(),
        type,
        message,
      };
      // Add the new alert to the beginning (optional, newest on top)
      // or end (newest at bottom) of the array. Let's add to end.
      setAlertMessages((prev) => [...prev, newAlert]);

      // Set a timer to automatically hide this specific alert
      if (duration > 0) { // Allow duration=0 for persistent alerts
        const timerId = setTimeout(() => {
          hideAlert(newAlert.id);
        }, duration);

        // Optional: Store timerId with the alert if you need to clear it early
        // For simplicity, we're not clearing timers here if manually closed
      }
    },
    [hideAlert] // Dependency: hideAlert
  );

  // Remove the problematic useEffect timer that only targeted the first alert
  // useEffect(() => { ... }, [alertMessages]); // REMOVE THIS

  const contextValue = {
    showAlert,
    // You could expose hideAlert here too if needed elsewhere
    // hideAlert,
  };

  // REMOVE the hardcoded test data
  // const alertMessage = [...];

  return (
    <AlertContext.Provider value={contextValue}>
      {/* Container for the alerts */}
      <Box
        sx={{
          position: 'fixed',
          bottom: 16, // Or 'bottom: 16'
          left: 16,
          display: 'flex',
          flexDirection: 'column', // Stack vertically
          gap: 1, // Spacing between alerts (theme.spacing * 1 = 8px by default)
          zIndex: (theme) => theme.zIndex.snackbar, // Use theme's snackbar zIndex
        }}
      >
        {/* Render alerts from state */}
        {alertMessages.map((alert) => (
          <Alert
            key={alert.id}
            severity={alert.type} // success, info, warning, error
            onClose={() => hideAlert(alert.id)} // Allow manual closing
            variant="filled"
            sx={{ width: "100%" }} // Make alert fill container width
          >
            <PTTranslate tk={alert.message} />
          </Alert>
        ))}
      </Box>
      {children}
    </AlertContext.Provider>
  );
};

export { AlertContext, AlertProvider };

